"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _extends3.default)({
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(0, 1)
    }, theme.typography.body1, (0, _defineProperty2.default)({
      color: theme.palette.primary.main,
      textAlign: 'center'
    }, theme.breakpoints.down('sm'), {
      padding: theme.spacing(2, 1)
    })),
    label: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 500
    }
  };
}, {
  name: 'NewsletterText'
});

function NewsletterText(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends3.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.label
  }, t('newsletterText/text1')), /*#__PURE__*/_react.default.createElement("span", null, t('newsletterText/text2')));
}

process.env.NODE_ENV !== "production" ? NewsletterText.propTypes = {
  classes: _propTypes.default.shape({
    label: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string
} : void 0;
NewsletterText.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = NewsletterText;
exports.default = _default;